export default class NotificationTypes {
    // Constants for easy access
    static DIVISION = 'division'
    static COLLECTION = 'collection'
    static FLOORPLAN = 'floorplan'
    static SALES_ORDER = 'sales_order'
    static LOT = 'lot'
    static SYSTEM_PROCESS = 'system_process'

    static types = [
        {
            key: this.DIVISION,
            label: 'Community',
            allowedMeta: ['division', 'collection', 'floorplan', 'sales_order', 'lot', 'system_process']
        },
        {
            key: this.COLLECTION,
            label: 'Collection',
            allowedMeta: ['division', 'floorplan', 'sales_order']
        },
        {
            key: this.FLOORPLAN,
            label: 'Floorplan',
            allowedMeta: ['division', 'sales_order']
        },
        {
            key: this.SALES_ORDER,
            label: 'Available Home',
            allowedMeta: ['division']
        },
        {
            key: this.LOT,
            label: 'Lot',
            allowedMeta: ['division','lot']
        },
        {
            key: this.SYSTEM_PROCESS,
            label: 'System Process',
            allowedMeta: ['division','system_process']
        }
    ]

    static getType(key) {
        return NotificationTypes.types.find(type => type.key === key);
    }

    static getLabel(key) {
        return NotificationTypes.getType(key)?.label;
    }

    static getAllowedMeta(key) {
        return NotificationTypes.getType(key)?.allowedMeta || [];
    }

    static getAllTypes() {
        return NotificationTypes.types;
    }

    static getValidTypes() {
        return NotificationTypes.types.map(type => type.key);
    }
}